import { render, staticRenderFns } from "./EditorViewItemHolder.vue?vue&type=template&id=f896387e&scoped=true&"
import script from "./EditorViewItemHolder.vue?vue&type=script&lang=js&"
export * from "./EditorViewItemHolder.vue?vue&type=script&lang=js&"
import style0 from "./EditorViewItemHolder.vue?vue&type=style&index=0&id=f896387e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f896387e",
  null
  
)

export default component.exports